import { TutorialDefinition, TutorialId } from '../interfaces';
import { TUTORIAL_TEXT } from '../text';

export const navigationBasicsTutorial: TutorialDefinition = {
  id: TutorialId.NavigationBasics,
  titleKey: 'guidedTutorial.navigationBasics.title',
  steps: [
    {
      id: 'press-w',
      narration: TUTORIAL_TEXT.navigationBasics.step1,
      keyHintLabel: 'W',
      awaitKeys: ['KeyW'],
    },
    {
      id: 'press-s',
      narration: TUTORIAL_TEXT.navigationBasics.step2,
      keyHintLabel: 'S',
      awaitKeys: ['KeyS'],
    },
    {
      id: 'press-a',
      narration: TUTORIAL_TEXT.navigationBasics.step3,
      keyHintLabel: 'A',
      awaitKeys: ['KeyA'],
    },
    {
      id: 'press-d',
      narration: TUTORIAL_TEXT.navigationBasics.step4,
      keyHintLabel: 'D',
      awaitKeys: ['KeyD'],
    },
  ],
};
